module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mbnskms2-7d0fd92393fabdf63bfb2b8f01cef6ff.jpg";